VjsAdmin.User = (function () {
    const init = function () {
        $('.resend-validation-link').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');

            const $modal = VjsAdmin.Modal.create({
                title: 'Resending Validation Email',
                body: '<i class="fa fa-refresh fa-spin fa-fw"></i>',
                footer: '<button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>',
            });
            $modal.modal();

            $.get(href, () => {
                $modal.find('.modal-body').html('<p>Validation email has been sent!</p>');
            }).fail((error) => {
                $modal
                    .find('.modal-body')
                    .html(
                        `<p>An error occurred while resending the validation email.</p><div class="alert alert-danger" role="alert">Error ${error.status}: ${error.statusText}</div>`,
                    );
            });
            return false;
        });

        $('.login-as-link').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');

            const $modal = VjsAdmin.Modal.create({
                title: 'Log in as User',
                body: '<i class="fa fa-refresh fa-spin fa-fw"></i>',
                footer: '<button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>',
            });
            $modal.modal();

            $.get(href, (data) => {
                $modal
                    .find('.modal-body')
                    .html(
                        '<p><strong>Right-click</strong> this link and choose the  <strong>"Open Link in Incognito Window"</strong> option:</p>'
                            + `<p class="text-center"><a href="${data.data.url}">${data.data.url}</a></p>`,
                    );
            }).fail((error) => {
                $modal
                    .find('.modal-body')
                    .html(
                        `<p>An error occurred while retrieving the login link.</p><div class="alert alert-danger" role="alert">Error ${error.status}: ${error.statusText}</div>`,
                    );
            });
            return false;
        });

        $('.user-logout-link').on('click', function (e) {
            e.preventDefault();
            if (!window.confirm('Are you sure you want to logout the user?')) return false;

            const $self = $(this);
            const href = $self.attr('href');

            $.post(href, {}, () => {
                $self.html("<i class='fa fa-check'></i> Logout");
                setTimeout(() => {
                    $self.text('Logout');
                }, 2000);
            }).fail(() => {
                window.alert('There was a problem logging out user.');
            });

            return false;
        });

        $('.change-password-link').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const form = $('<div>').html($('#change-password-template').html());
            const submitButton = $('<button type="button" class="btn btn-green">Change Password</button>');
            const closeButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>');

            $(submitButton).on('click', (ee) => {
                ee.preventDefault();

                $modal.find('.modal-footer button').prop('disabled', true).html('Working... <i class="fa fa-spinner fa-pulse fa-fw"></i>');

                $('body').css('cursor', 'wait');

                $.post(href, $(form).find('form').serialize(), () => {
                    $modal
                        .find('.modal-body')
                        .html(
                            '<div class="alert alert-success" role="alert"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i> Password Changed!</div>',
                        );
                    $modal.find('.modal-footer button').replaceWith(closeButton);
                }).fail((error) => {
                    $modal.find('.modal-body .alert').remove();
                    $modal
                        .find('.modal-body')
                        .prepend(`<div class="alert alert-danger" role="alert">Error: ${error.responseJSON.message}</div>`);
                    $modal.find('.modal-footer button').html('Change Password').prop('disabled', false);
                    $('body').css('cursor', 'default');
                });
            });

            const $modal = VjsAdmin.Modal.create({
                title: 'Change Password',
                body: form,
                footer: submitButton,
            });
            $modal.modal();

            return false;
        });
    };

    return {
        init,
    };
}());
